import { createContext, useContext, useEffect } from "@wordpress/element";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
	getProductCollections,
	selectProductCollections,
} from "store/vino/productCollectionsSlice";

export const ProductCollectionsContext = createContext({});
export const useProductCollectionContext = () =>
	useContext(ProductCollectionsContext);

export const ProductCollectionContextProvider = ({ children }) => {
	const dispatch = useDispatch();
	const collections = useSelector(selectProductCollections);

	useEffect(() => {
		dispatch(getProductCollections());
	}, [dispatch]);

	return (
		<ProductCollectionsContext.Provider value={{ collections }}>
			{children}
		</ProductCollectionsContext.Provider>
	);
};

ProductCollectionContextProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
